<template>
  <div class="print-description-wrapper">
    <div class="total-title">360.CN集团手机邮箱使用</div>
    <div class="title">1. 目的</div>
    <p>为了方便360.CN集团用户使用手机邮箱，移动办公提高工作效率</p>
    <div class="title">2. 适用范围</div>
    <p>360集团内部，邮箱为XXX@360.CN</p>
    <div class="title">3. 权责声明</div>
    <p
      class="indent"
    >此文档为360信息化部IT所编写，版权归360信息化部所有。此文档禁止用于商业用途，禁止分享传播到公司外部组织，如有违反，将按照HR员工手册和信息安全部相关规章制度进行处理。</p>
    <div class="title">4. 手机邮箱使用说明</div>
    <div class="sub-title red">4.1自主管理平台</div>
    <p>
      <strong>SSC共享服务中心</strong>
      <a href="https://ssc.corp.qihoo.net">https://ssc.corp.qihoo.net</a>
      <br />
      <span>我的地盘-IT中心-我的手机邮箱</span>
    </p>
    <p>
      <strong>推推APP</strong>
      <a href="http://it.home.qihoo.net">http://it.home.qihoo.net</a>
      <br />
      <span>应用中心-IT相关-手机邮箱（申请）</span>
      <br />
      <span>我的-手机邮箱（管理）</span>
    </p>
    <div class="sub-title">4.2 首次使用手机邮箱的用户</div>
    <p>
      需先到SSC共享服务中心 （以下简称SSC）/ 推推 APP中“我的手机邮箱”模块，申请开通手机邮箱功能（
      <span class="red">后续无需再次申请开通手机邮箱功能</span>）
      <!-- <br />SSC共享服务中心地址：
      <a href="https://ssc.corp.qihoo.net">https://ssc.corp.qihoo.net</a>
      <br />推推 APP 下载地址：
      <a href="http://it.home.qihoo.net">http://it.home.qihoo.net</a>-->
    </p>
    <div class="sub-title">4.3 默认手机邮箱的设备数量</div>
    <p>应安全部要求，每人默认可配置1台设备，最大5台设备。后期如有工作需求，可登陆SSC / 推推 APP中申请变更。</p>
    <div class="sub-title red">4.4 重新配置手机设备</div>
    <p>无需在SSC / 推推APP操作（删除设备），直接在原APP（如Outlook）重新配置即可</p>
    <div class="sub-title red">4.5 手机设备更换</div>
    <p>
      1) 旧手机设备，在配置中删除邮箱账号
      <br />2) 登录SSC/推推APP “我的手机邮箱”：
      <br />
      <span class="twoem">删除旧设备——等待15分钟——配置新设备——激活新设备</span>
    </p>
    <div class="sub-title red">4.6 自助进行激活、删除、变更设备数量</div>
    <p>可通过在在SSC / 推推APP自助对手机设备进行 激活、删除、变更设备数量</p>
    <div class="sub-title red">4.7 手机邮箱使用流程如下</div>
    <p>
      <img src="../../assets/img/pdf2H5/iphoneEmail/img_1.png" />
    </p>
    <div class="sub-title">4.8 遇到问题支持方式</div>
    <p>
      请发邮件到：
      <a href="mailto:IT@360.cn" class="link">IT@360.cn</a> 或拨打
      <a href="tel:010-58781234">010-58781234</a>
    </p>

    <div class="title">5. 手机邮箱配置方法</div>
    <div class="sub-title">5.1 IOS苹果端</div>
    <p>
      1. 打开“设置”，找到“账户与密码”
      <img src="../../assets/img/pdf2H5/iphoneEmail/img_2.png" />
      2. 点击“添加账户”
      <img src="../../assets/img/pdf2H5/iphoneEmail/img_3.png" />
      3. 选择邮箱连接方式为“Exchange”
      <img src="../../assets/img/pdf2H5/iphoneEmail/img_4.png" />
      4. 填写自己的“邮箱地址”，然后点击“下一步”输入密码后，继续点击“下一步”
      <img
        src="../../assets/img/pdf2H5/iphoneEmail/img_5.png"
      />
      5. 注意填写“服务器”和“域”，“用户名”一般为自己名字的全拼，填写后点击“下一步”
      <br />
      <span class="twoem">
        <span class="weight">服务器：</span>mail.360.cn
      </span>
      <br />
      <span class="twoem">
        <span class="weight">域：</span>corp
      </span>
      <br />
      <span class="twoem">
        <span class="weight">用户名：</span>
        域账号，不用输入@360.cn
      </span>
      <img src="../../assets/img/pdf2H5/iphoneEmail/img_6.png" />
      6. 选择同步选项，
      <span class="red">如无特殊需求请勿勾选通讯录，</span>其他默认
      <img src="../../assets/img/pdf2H5/iphoneEmail/img_7.png" />
      7. Outlook会收到“暂时阻止”提醒邮件
      <img src="../../assets/img/pdf2H5/iphoneEmail/img_8.png" />
      8. 此时登录SSC/推推 APP，自助对手机设备进行激活 、删除即可
      <img
        src="../../assets/img/pdf2H5/iphoneEmail/img_9.png"
      />
    </p>
    <div class="sub-title">5.2 Android安卓端</div>
    <p>可使用Android自带客户端 或Outlook APP</p>
    <p>
      1. 首先找到并打开手机自带的“电子邮件”app
      <img src="../../assets/img/pdf2H5/iphoneEmail/img_10.png" />
      2. 选择邮箱连接类型为“Exchange”
      <img src="../../assets/img/pdf2H5/iphoneEmail/img_11.png" />
      3. 接下来填写自己的“邮箱地址”和“密码”，点击“登录”
      <img src="../../assets/img/pdf2H5/iphoneEmail/img_14.png" />
      4. 注意填写“服务器”和“域”，“用户名”一般为自己名字的全拼，填写后点击“下一步”
      <br />
      <span class="twoem">
        <span class="weight">服务器：</span>mail.360.cn
      </span>
      <br />
      <span class="twoem">
        <span class="weight">域：</span>corp
      </span>
      <br />
      <span class="twoem">
        <span class="weight">用户名：</span>
        域账号，不用输入@360.cn
      </span>
      <img src="../../assets/img/pdf2H5/iphoneEmail/img_15.png" />
      5. Outlook会收到“暂时阻止ActiveSync”邮件提醒，
      <img
        src="../../assets/img/pdf2H5/iphoneEmail/img_8.png"
      />
      6. 登录SSC/推推 APP，自助对手机设备进行激活 、删除即可
      <img
        src="../../assets/img/pdf2H5/iphoneEmail/img_9.png"
      />
    </p>
  </div>
</template>
<script>
export default{
  
}
</script>
<style lang="scss" scoped>
.print-description-wrapper {
  min-height: 100vh;
  padding: 15px;
  background: #fff;
  font-size: 14px;
  img {
    width: 100%;
    margin: 0.5em 0;
  }
  .title {
    font-size: 16px;
    font-weight: bold;
  }
  p {
    margin: 1em 0;
  }
  .sub-title {
    font-weight: bold;
  }
  .total-title {
    font-weight: bold;
    font-size: 20px;
    text-align: center;
    padding: 1em 0;
  }
  .inline-img {
    display: inline;
    vertical-align: middle;
    width: 30px;
  }
  .red {
    color: red;
  }
  .indent {
    text-indent: 1em;
  }
  .twoem {
    /* text-indent: 2em; */
    margin-left: 1em;
  }
  .weight {
    font-weight: bold;
  }
  a {
    color: $link-a;
  }
}
</style>